import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import AutoCreateLider from "./pages/AutoCreateLider";
import Formulario from "./pages/Formulario";
import Menu from "./pages/Menu";
import AdminLogin from "./pages/AdminLogin";
import AdminMenu from "./pages/AdminMenu";
import AdminEventos from "./pages/AdminEventos";
import Inicio from "./pages/Inicio";
import Eventos from "./pages/Eventos";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import AuditoriaLogin from "./pages/AuditoriaLogin";
import Auditoria from "./pages/Auditoria";
import AdminNiveles from "./pages/AdminNiveles";
import AdminParticipantes from "./pages/AdminParticipantes";
import AdminLideres from "./pages/AdminLideres";
import AdminAuditoria from "./pages/AdminAuditoria";
import EstructuraNiveles from "./pages/EstructuraNiveles";
import LoginEventoMasivo from "./pages/LoginEventoMasivo";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EventosMasivos from "./pages/EventosMasivos";
import ConsultaEventosMasivos from "./pages/ConsultaEventosMasivos";


function App() {
  return (
    <Router>
      {/* ToastContainer debe estar aquí, dentro del Router pero fuera de Routes */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable />
      <Routes>

        {/* Rutas públicas */}
        <Route path="/" element={<Inicio />} />
        <Route path="/administrador" element={<AdminLogin />} />
        <Route path="/auditor" element={<AuditoriaLogin />} />
        <Route path="/participante" element={<Login />} />
        <Route path="/eventos" element={<LoginEventoMasivo />} />

        {/* Rutas protegidas para líderes */}
        <Route element={<PrivateRoute />}>
          <Route path="/menuParticipantes" element={<Menu />} />
          <Route path="/registroParticipantes" element={<Formulario />} />
          <Route path="/eventosParticipantes" element={<Eventos />} />
        </Route>

        {/* Rutas protegidas para administradores */}
        <Route element={<AdminRoute />}>
          <Route path="/administradorMenu" element={<AdminMenu />} />
          <Route path="/administradorEventos" element={<AdminEventos />} />
          <Route path="/registroLider" element={<AutoCreateLider />} />
          <Route path="/auditoriaMonytor" element={<Auditoria />} />
          <Route path="/administradorNiveles" element={<AdminNiveles />} />
          <Route path="/administradorParticipantes" element={<AdminParticipantes />} />
          <Route path="/administradorLideres" element={<AdminLideres />} />
          <Route path="/administradorAuditoria" element={<AdminAuditoria />} />
          <Route path="/estructuraLideresNiveles" element={<EstructuraNiveles />} />
          <Route path="/EventosMasivos" element={<EventosMasivos />} />
          <Route path="/consultarEventosMasivos" element={<ConsultaEventosMasivos />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
